module.exports = __webpack_public_path__ + "img/2.7df912b8.png";